// @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#image_types
export const UPLOAD_ACCEPTED_FILE_TYPES_IMAGES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
  // Windows only reports a MIME type for .heic/.heif when Microsoft's HEIF
  // Image Extensions are installed; otherwise `file.type` is "". Listing the
  // extensions lets the OS picker show them and lets react-dropzone accept
  // them by file name.
  ".heic",
  ".heif",
]

export const UPLOAD_ACCEPTED_FILE_TYPES_DOCUMENTS = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]
